import api from "@/services/api";

export default {
    namespaced: true,
    state: () => ({
        products: [],
        loading: false,
        error: null
    }),
    mutations: {
        SET_PRODUCTS(state, products) {
            state.products = products;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_ERROR(state, error) {
            state.error = error;
        }
    },
    actions: {
        async fetchProducts({ commit }) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await api.get("/Product/getAll");
                commit("SET_PRODUCTS", res.data);
            } catch (err) {
                commit("SET_ERROR", err.message);
            } finally {
                commit("SET_LOADING", false);
            }
        }
    },
    getters: {
        allProducts: (state) => state.products,
        isLoading: (state) => state.loading,
        hasError: (state) => state.error
    }
};
